/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { Navigate } from "react-router-dom";
import Projects from "./Projects";
import InstanceWrapper from "../../shared-components/layouts/InstanceWrapper";
import ProjectForm from "./instance/ProjectForm";
import authRoles from "../../auth/authRoles";

const ProjectConfig = {
  routes: [
    {
      path: "projects",
      element: <Projects />,
    },
    {
      path: "projects/:id",
      element: <InstanceWrapper />,
      auth: authRoles.admin,
      children: [
        {
         path: "",
         element: <Navigate to="/projects" />,
        },
        {
          path: "edit",
          element: <ProjectForm />,
        }
      ],
    },
  ],
};

export default ProjectConfig;
